<template>
  <div>
    <v-row>
      <template v-if="loading_folders">
        <v-col md="4" v-for="(i, index) in 3" :key="'skeleton-' + index">
          <CardSkeletonList />
        </v-col>
      </template>
      <template v-else>

        <v-col v-for="(folder, index) in folderData.sub_folder" :key="'folder-' + index" cols="12" sm="6" md="3">
          <CardFolder :folder="folder" @click="$emit('open-folder', folder)" @editItem="$emit('editItem', folder)"
            @deleteItem="$emit('deleteItem', folder)"  />
        </v-col>
        <ListEmpty
          v-if="(!folderData.sub_folder || !folderData.sub_folder.length)"  />
      </template>
    </v-row>
  </div>
</template>


<script>
import CardFolder from './CardFolder.vue'
import ListEmpty from './ListEmpty.vue';
import CardSkeletonList from '../CardSkeletonList.vue' ;
export default {
  name: 'ListFile',
  components: {
    CardFolder,
    ListEmpty,
    CardSkeletonList
  },
  props: {
    folderData: {
      type: Object,
      required: true
    },
    editItem: {
      type: Function,
      default: () => { }
    },
    deleteItem: {
      type: Function,
      default: () => { }
    },
    loading_folders: {
      type: Boolean,
      default: false
    }
  }
}
</script>
